import { createContext, useContext } from 'react';

interface BlockContextValue {
  blockRef: React.RefObject<HTMLDivElement>;
  setGeneralHeaderElement?: (element: HTMLDivElement | null) => void;
  setPrefaceElement?: (element: HTMLElement | null) => void;
  setTrailerElement?: (element: HTMLElement | null) => void;
  pageNumber?: number | undefined;
  isContinuation?: boolean | undefined;
  continuationIndex?: number | undefined;
  sliceWindow?:
    | { dataHeightPx: number; startRowIndex: number; columnWidths?: Readonly<Record<string, number>> | undefined }
    | undefined;
}

export const BlockContext = createContext<BlockContextValue | null>(null);
BlockContext.displayName = 'BlockContext';

export const useBlockContext = () => {
  const context = useContext(BlockContext);
  if (!context) {
    throw new Error('useBlockContext must be used within a BlockContext provider');
  }
  return context;
};
